import React from 'react';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { reports as ReportsView } from 'ui/views/layouts/reports';
import { ReportsService } from 'services/reports';
import { clearMemberManagementState } from 'resolvers/memberManagementState';

// React view component to render

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { Reports } from 'ui/containers/Reports';
 *
 * // render
 * <Reports propName='propValue'/>
 */
export class Reports extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // clear member management state
        clearMemberManagementState();

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.reportsService = new ReportsService();
        
        // start component data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'Reports.fetchComponentData()' );

        // cancel ongoing request
        this.reportsService.cancel();

        // get status and service data
        const { status, data } = await this.reportsService.fetchComponentData();

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unMounts, cleanup resources.
     */
    componentWillUnmount() {
        this.reportsService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <ReportsView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...this.state.componentData }
            />
        );
    }
}

// set display name
Reports.displayName = 'Reports';

// set default props
Reports.defaultProps = {};

// prop types
Reports.propTypes = {};
